module.exports = __webpack_public_path__ + "static/media/drawflow.a3dd9fa5.jpeg";